import React, { useState } from 'react';
import {alertModal } from '../../../../components/modals/antd-modals';
import { useDispatch, useSelector } from 'react-redux';
import {signIn} from '../../../../redux/authentication/actionCreator'
import { useHistory } from "react-router-dom";

const successModal = (dialog, dispatch, history) =>{
    
    alertModal.success({
        title: `SUCCESS`,
        content: (
            <div>
                <p>{`${dialog.message}`}</p>
            </div>
        ),
        onOk() {
            dispatch({type:'RESET_DATA'})
            history.push(dialog.url)
        },
    });
}

const Success = () => {
    const dialog = useSelector(state => state.auth.dialog)
    const history = useHistory();
    const dispatch = useDispatch()
    return (
        <>
        {successModal(dialog, dispatch, history)}
        </>
    )
    
};


export default Success;
